import AddIcon from '../../../../../icons/Plus';
import SendIcon from '../../../../../icons/Send';
import ResendMoneyIcon from '../../../../../icons/ResendMoney';
import * as links from '../../../../../../constants/links';
import formatTime from 'mn-utils/formatTime';
import lowerFirst from 'mn-utils/lowerFirst';
import {pushLocation} from '../../../../../../router';
import {
  apiAdminPayoutKrakenManualRefreshTransaction,
  apiAdminPayoutStartKrakenNium,
} from '../../../../../../api/admin/payout/kraken';
import React from 'react';
import Ripple from '../../../../../dumb/Ripple';
import {openV1PopupInfo} from '../../../../../../emitters/popup';
import withState from '../../../../../../utils/withState';

module.exports = withState((setState, self) => {
  self.state = {};

  const handleStartPayout = (params) => {
    apiAdminPayoutStartKrakenNium(params).finally((error) => {
      setState({
        loading: false,
      });
      error || (
        openV1PopupInfo([
          'Start payout Kraken to Nium',
          'Have been success started',
        ])
      );
    });
  };

  const handleForceRefreshLastTransaction = (params) => {
    apiAdminPayoutKrakenManualRefreshTransaction(params).finally((error) => {
      setState({
        loading: false,
      });
      error || (
        openV1PopupInfo([
          'Refresh transaction',
          'Have been success refreshed',
        ])
      );
    });
  };

  return (state, props) => {
    const {
      groupId,
      currency,
      krakenWithdraws,
      className,
    } = props;

    return (
      <section className={className}>
        <div className="layoutRow fhaS fvaC wmin830">
          <h3>Kraken withdraws</h3>
          <Ripple
            className="wsNW ml20 dF aiC h42 p7 r7 bgc0.25 (bgc0.5):h"
            onClick={() => {
              pushLocation({
                path: `${links.LINK_ADMIN_PAYOUT_NIUM_TRANSACTION_ADD}/${groupId}/${currency}`,
              });
            }}
          >
            <AddIcon className="w20 h20"/>
            <span className="ml10">Add manual transaction</span>
          </Ripple>

          <Ripple
            className="wsNW ml20 dF aiC h42 p7 r7 bgc0.25 (bgc0.5):h"
            onClick={() => {
              handleStartPayout({group_id: groupId});
            }}
          >
            <SendIcon className="w36 h36"/>
            <span className="ml10">Start a payout (Kraken -&gt; Nium)</span>
          </Ripple>

          <Ripple
            className="wsNW ml20 dF aiC h42 p7 r7 bgc0.25 (bgc0.5):h"
            onClick={() => {
              handleForceRefreshLastTransaction({group_id: groupId});
            }}
          >
            <ResendMoneyIcon className="w36 h36"/>
            <span className="ml10">Force refresh last transaction</span>
          </Ripple>
        </div>

        {krakenWithdraws.length ? (
          <div className="wmin830 mt20 cfx">
            <div className="dTB bdclC w lt">
              <div className="dTBHG bb2 bcbC.2 bsb">
                <div className="dTBR bb2 bcbC.2 bsb tc cA4A7AC f16 fw5 dTBC>1">
                  <div className="w100">ID</div>
                  <div className="w90">Key</div>
                  <div className="w70">Asset</div>
                  <div className="w100">Info</div>
                  <div className="w80">Amount</div>
                  <div className="w70">Fee</div>
                  <div className="w100">Time</div>
                  <div className="w90">Status</div>
                  <div className="w70">Method</div>
                </div>
              </div>
              <div className="dTBRG">
                {krakenWithdraws.map((withdraw) => {
                  const date = formatTime(withdraw.time, '{dd} {mmm}, {yyyy}');
                  const time = formatTime(withdraw.time, '{hh}:{MM}:{ss} {TT}');

                  return (
                    <div
                      key={withdraw.ref_id}
                      className="dTBR p5 tc olN tdN w cF bgF.03:h (dTBC|vaM|p10)>1"
                    >
                      <div>{withdraw.ref_id}</div>
                      <div>{withdraw.key}</div>
                      <div>{withdraw.asset}</div>
                      <div>{withdraw.info}</div>
                      <div>{withdraw.amount}</div>
                      <div>{withdraw.fee}</div>
                      <div>
                        <div>{date}</div>
                        <div className="c717275 fw4 mt8">
                          {time}
                        </div>
                      </div>
                      <div className={`c ${lowerFirst(withdraw.status)}
                        (c66E3F7).pending
                        (cF7E766).initial
                        (cDE66F7).settled
                        (c00AE00).success
                        (cF76666).failure
                    `}>
                        {withdraw.status}
                      </div>
                      <div>{withdraw.method}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : null}
      </section>
    );
  };
});
